// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

export function memo<T extends Function>(fnToMemoize: T): T {
  let prevArgs = [{}];
  let result: any;

  return function (...newArgs: any[]) {
    if (hasDifferentArgs(prevArgs, newArgs)) {
      result = fnToMemoize(...newArgs);
      prevArgs = newArgs;
    }
    return result;
  } as any;
}

function hasDifferentArgs(prev: unknown[], next: unknown[]): boolean {
  if (prev.length !== next.length) return true;
  for (let i: number = 0; i < prev.length; i++) {
    if (!Object.is(prev[i], next[i])) return true;
  }
  return false;
}